var Rangeslider = new Class({
	Implements: [Options, Events],

	options: {
		cls: 'w_rangeslider',
		title: 'range: ',
		titleIcon: null,
		divider: ' - ',
		slider: null,
		min: null,
		max: null,
		__format: function(e){ return e; },
		config: null,
		type: 'horisontal' //can be 'vertical' or horisontal
	},

	initialize: function(element, options){
		this.setOptions(options);

		this._element = element || document.getElement('.w_rangeslider');

		if(this._element){
			this.build();
			this.handleAda();
		}
	},

	build: function(){
		var opts = this.options;
		var self = this;
		var _self = this._element;

		this.enabled = true;
		this._min_input = (_self.getElement('input') || new Element('input[type="hidden"]')).inject(_self, 'before');
		this._max_input = (_self.getElement('input') || new Element('input[type="hidden"]')).inject(_self, 'before');

		var config;

		try{
			var _config = _self.getElement('.' + opts.cls + '_config');

			if (opts.config) {
				config = opts.config;
			} else if (_config) {
				config = JSONMOO.decode(_config.get('html'), false);
			} else {
				config = JSONMOO.decode(_self.get('html'), false);
			}
		}catch(e){}

		if(typeOf(config) == 'object' && config.keys && config.values){
			this.values = config.keys;

			if(this.values.length == config.values.length){
				this.labels = config.values;
			}else{
				this.labels = config.keys;
			}
		}else if(typeOf(config) == 'array'){
			this.values = config;
			this.labels = opts.__format(config);
		}else{
			if(console){
				console.warn('Initial content of the widget "' + _self.get('class') + '" has to be either an object with keys and values or an array. i.e. : {\"keys\":[1, 2, 3], \"values\":[a,b,c]} or [1, 2, 3]. Double quotes matter.\nYou have:');
				// console.log(_self.get('html'));
			}

			return;
		}

		if(opts.type == 'vertical'){
			this.values.reverse();
			this.labels.reverse();
		}

		if((opts.min || opts.min == 0) && this.values.contains(opts.min.toInt())){
			this._min_input.set('value', opts.min);
		}

		if((opts.max || opts.max == 0) && this.values.contains(opts.max.toInt())){
			this._max_input.set('value', opts.max);
		}

		if(this._min_input.get('value') == ''){
			this._min_input.set('value', this.values[0]);
		}

		if(this._max_input.get('value') == ''){
			this._max_input.set('value', this.values[this.values.length-1]);
		}

		this._min_input.addEvent('change', function(){ self.fireEvent('change') });
		this._max_input.addEvent('change', function(){ self.fireEvent('change') });

		_self.set('html', '').show();

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android'){
			this._element.addClass('_touch_support');
			this.with_touch_support = true;
		}

		if(!opts.slider){
			if (this.with_touch_support){
				opts.slider = 'off';
			} else {
				opts.slider = 'on';
			}
		}

		if(opts.slider == 'on'){
			if(this.options.type == 'vertical'){
				this._element.addClass('_vertical clearfix');
			}

			this.create_elements();
			this.create_slider();
		}else{
			this.create_select();
		}

		if(this.options.reset_initialy){
			this.reset();
		}

	},

	create_select: function(){
		var self = this;
		var _self = this._element;
		var opts = this.options;

		_self.addClass('clearfix');

		if (!_self.getElement('.' + opts.cls + '_title')) {
			new Element('div', {'class': opts.cls + '_title _no_slider'}).set('text', opts.title).inject(_self);
		}

		var _min_select = this._min_select = new Element('select').inject(_self);

		this.labels.each(function(e, i){
			new Element('option', {'text': e, 'value': self.values[i]}).inject(_min_select);
		});

		new Element('span.between_selects', {'text': 'to'}).inject(_self);

		var _max_select = this._max_select = _min_select.clone().inject(_self);

		var min_index = 0;
		var max_index = this.values.length - 1;

		var min_value = this._min_input.get('value');
		var max_value = this._max_input.get('value');

		this.values.each(function(e, i){
			if(min_value == e){
				min_index = i;
			}

			if(max_value == e){
				max_index = i;
			}
		});

		_min_select.selectedIndex = min_index;
		_max_select.selectedIndex = max_index;

		_min_select.addEvent('change', function(){
			var val = _min_select.get('value');

			self.labels.each(function(e, i){
				if(val == e){
					self._min_input.set('value', self.values[i]);
				}
			});

			self._min_input.set('value', val);

			self.fireEvent('complete', [self._min_input.get('value'), self._max_input.get('value'), self._min_input.get('value'), self._max_input.get('value'), 'min']);
		});

		_max_select.addEvent('change', function(){
			var val = _max_select.get('value');

			self.labels.each(function(e, i){
				if(val == e){
					self._max_input.set('value', self.values[i]);
				}
			});

			self._max_input.set('value', val);

			self.fireEvent('complete', [self._min_input.get('value'), self._max_input.get('value'), self._min_input.get('value'), self._max_input.get('value'), 'max']);
		});

		var _min_ss = new Element('div', {'class': 'w_styled_select'}).inject(_min_select, 'before');
		var _max_ss = new Element('div', {'class': 'w_styled_select'}).inject(_max_select, 'before');

		_min_ss.adopt(_min_select);
		_max_ss.adopt(_max_select);

		new StyledSelect(_min_ss);
		new StyledSelect(_max_ss);
	},

	create_elements: function(){
		var cls = this.options.cls;
		var fcls = '.' + cls;
		var _self = this._element;

		var knob_image;

		if(this.options.type == 'vertical'){
			knob_image = Res_i + '/w/rangeslider/vertical/knob.png';
		}else{
			knob_image = Res_i + '/w/rangeslider/knob.png';
		}

		var html =	'<div class="' + cls + '_title">' + (this.options.titleIcon ? '<i class="fa fa-usd" aria-hidden="true"></i> ' : '') + (_self.getAttribute('data-title') || this.options.title) + '</div>' +
								'<div class="' + cls + '_labels">' +
									'<span class="min"></span>' +
									'<span class="divider">' + this.options.divider + '</span>' +
									'<span class="max"></span>' +
								'</div>' +
								'<div class="' + cls + '_scale">' +
									'<div class="' + cls + '_bkg clearfix">'+
										'<div class="center">&nbsp;</div>' +
									'</div>' +
									'<button aria-label="minimum" class="' + cls + '_dragger _min">' +
										'<div class="veil">&nbsp;</div>' +
										'<div class="knob">' +
											'<img src="' + knob_image + '"/>' +
										'</div>' +
									'</button>' +
									'<button aria-label="maximum" class="' + cls + '_dragger _max">' +
										'<div class="veil">&nbsp;</div>' +
										'<div class="knob">' +
											'<img src="' + knob_image + '"/>' +
										'</div>' +
									'</button>' +
								'</div>';
		if (this.options.v3) {
			html = '<div class="' + cls + '_labels">' +
				'<div class="min-label"><span>Minimum Price</span>' +
				'<input type="text" class="min_input" disabled>' +
				'</div>' +
				'<div class="hyphen"> - </div>' +
				'<div class="max-label"><span>Maximum Price</span>' +
				'<input type="text" class="max_input" disabled>' +
				'</div>' +
				'<span class="min" style="display:none"></span>' +
				'<span class="divider" style="display:none">' + this.options.divider + '</span>' +
				'<span class="max" style="display:none"></span>' +
				'</div>' +
				'<div class="' + cls + '_scale">' +
				'<div class="' + cls + '_bkg clearfix">' +
				'<div class="center">&nbsp;</div>' +
				'</div>' +
				'<button aria-label="minimum" class="' + cls + '_dragger _min">' +
				'<div class="veil">&nbsp;</div>' +
				'<div class="knob">' +
				'<img src="' + knob_image + '"/>' +
				'</div>' +
				'</button>' +
				'<button aria-label="maximum" class="' + cls + '_dragger _max">' +
				'<div class="veil">&nbsp;</div>' +
				'<div class="knob">' +
				'<img src="' + knob_image + '"/>' +
				'</div>' +
				'</button>' +
				'</div>';
		}

		_self.set('html', html);

		this._scale = _self.getElement(fcls + '_scale');

		this._min_dragger = _self.getElement(fcls + '_dragger._min');
		this._max_dragger = _self.getElement(fcls + '_dragger._max');

		this._min_dragger._veil = this._min_dragger.getElement('.veil');
		this._max_dragger._veil = this._max_dragger.getElement('.veil');

		if(this.options.type == 'vertical'){
			// this.playground = this._scale.getComputedSize().height - this._min_dragger.getSize().y - this._max_dragger.getSize().y;
			this.playground = this._scale.getSize().y - this._min_dragger.getSize().y - this._max_dragger.getSize().y;
		}else{
			// this.playground = this._scale.getComputedSize().width - this._min_dragger.getSize().x - this._max_dragger.getSize().x;
			this.playground = this._scale.getSize().x - this._min_dragger.getSize().x - this._max_dragger.getSize().x;
		}

		if(this.playground < this.values.length && console){
			console.warn('Too many values (' + this.values.length + ') for the slider "' + _self.get('class') + '".\nThe slider won\'t work properly!!!');
		}

		this.step_px = this.playground / (this.values.length-1);

		this._min_label = _self.getElement(fcls + '_labels .min');
		this._max_label = _self.getElement(fcls + '_labels .max');
		this._min_input_val = _self.getElement(fcls + '_labels .min_input');
		this._max_input_val = _self.getElement(fcls + '_labels .max_input');

		if (this._min_input_val && this._max_input_val) {
			this._min_input_val.set('value', this.labels[0]);
			this._max_input_val.set('value', this.labels[this.labels.length - 1]);
		}
	},

	handleAda: function() {
		var self = this, opts = this.options, labels = this.labels;
		var isVertical = opts.type == 'vertical';

		function setStaticAriaValue(handle) {
			if (handle) {
				handle.setAttribute('role', 'slider');
				handle.setAttribute('aria-valuemin', opts.min);
				handle.setAttribute('aria-valuemax', opts.max);
			}
		}

		function getCurrentValue(pos) {
			var v = Math.ceil(pos / self.step_px);
			return labels[v];
		}

		[this._min_dragger, this._max_dragger].forEach(setStaticAriaValue);

		this._element.addEventListener('keydown', function(event) {
			var leftBeingFocused = document.activeElement === self._min_dragger;
      var rightBeingFocused = document.activeElement === self._max_dragger;
			var step = self.step_px;
      if(!leftBeingFocused && !rightBeingFocused)
        return;
			var eventName = leftBeingFocused ? 'minChange' : 'maxChange';
			var reduce = leftBeingFocused ? 0 : self._min_dragger.size;
			
			var currentDraggable = document.activeElement;
			var nextPos = opts.type === 'vertical' ? currentDraggable.getPosition(self._scale).y : currentDraggable.getPosition(self._scale).x
			
			function boundMe(pos) {
				if(pos < currentDraggable.min_pos)
					return currentDraggable.min_pos
				if(pos > currentDraggable.max_pos)
					return currentDraggable.max_pos
				return pos;
			}

      switch(event.which) {
        case 37: // Left.
        case 38: // Up.
					nextPos = boundMe(nextPos - step);
					self.set_pos(currentDraggable, nextPos);
					self.fireEvent(eventName, [nextPos - reduce]);
          break;
        case 39: // Right.
        case 40: // Down.
					nextPos = boundMe(nextPos + step);
					self.set_pos(currentDraggable, nextPos);
					self.fireEvent(eventName, [nextPos - reduce]);
          break;
        default:
          return;
			}
			currentDraggable.setAttribute('aria-valuenow', getCurrentValue(nextPos));
			// need a diffrent variable than _current_draggable to prevent mousemove event interfering 
			self._current_tab = currentDraggable;

			// self.fireEvent('maxChange', [self._max_dragger.getPosition(self._scale).x - self._min_dragger.size]);

			// update min and max
			if(isVertical) {
				if(leftBeingFocused) {
					// update max min
					self._max_dragger.max_pos = self._min_dragger.getPosition(self._scale).y - self._max_dragger.size;
				}
				else {
					self._min_dragger.min_pos = self._max_dragger.getPosition(self._scale).y + self._max_dragger.size;
				}
			}
			else {
				if(leftBeingFocused) {
					self._max_dragger.min_pos = self._min_dragger.getPosition(self._scale).x + self._min_dragger.size;
				}
				else {
					self._min_dragger.max_pos = self._max_dragger.getPosition(self._scale).x - self._min_dragger.size;
				}
			}

			self.fireEvent('change');
		})
	},

	create_slider: function(){
		var self = this;
		var _self = this._element;
		var opts = this.options;
		var values = this.values;
		var labels = this.labels;

		if(opts.type == 'vertical'){
			this._min_dragger.size = this._min_dragger.getSize().y;
			this._max_dragger.size = this._max_dragger.getSize().y;
			this._scale.size = this._scale.getSize().y;
		}else{
			this._min_dragger.size = this._min_dragger.getSize().x;
			this._max_dragger.size = this._max_dragger.getSize().x;
			this._scale.size = this._scale.getSize().x;
		}

		this._min_dragger.half_size = (this._min_dragger.size / 2).round();
		this._max_dragger.half_size = (this._max_dragger.size / 2).round();

		if(opts.type == 'vertical'){
			this._min_dragger.min_pos = this._max_dragger.size;
			this._min_dragger.max_pos = this._scale.size - this._min_dragger.size;

			this._max_dragger.min_pos = 0;
			this._max_dragger.max_pos = this._scale.size - this._max_dragger.size - this._min_dragger.size;
		}else{
			this._min_dragger.min_pos = 0;
			this._min_dragger.max_pos = this._scale.size - this._max_dragger.size - this._min_dragger.size;

			this._max_dragger.min_pos = this._min_dragger.getSize().x;
			this._max_dragger.max_pos = this._scale.size - this._max_dragger.size;
		}

		var init_pos;

		function setInitPos() {
			if(!self.enabled) return;

			self._current_draggable = this;

			if(opts.type == 'vertical'){
				init_pos = this.getPosition().y;
			}else{
				init_pos = this.getPosition().x;
			}
			return false;
		}

		this._min_dragger.addEvents({
			// 'focus': setInitPos,
			'mousedown': setInitPos,
			'touchstart': setInitPos
		});

		this._max_dragger.addEvents({
			// 'focus': setInitPos,
			'mousedown': setInitPos,
			'touchstart': setInitPos
		});

		var in_element = false;

		this._element.addEvents({
			'touchstart': function(e){
				in_element = true;
			},

			'touchend': function(e) {
				in_element = false;
			},

			'touchmove': function(e){
				if(!self.enabled || !self._current_draggable) return;

				var pos;

				if(opts.type == 'vertical'){
					pos = e.targetTouches[0].pageY - _self.getPosition().y - self._current_draggable.half_size;
				}else{
					pos = e.targetTouches[0].pageX - _self.getPosition().x - self._current_draggable.half_size;
				}

				if(pos < self._current_draggable.min_pos){
					pos = self._current_draggable.min_pos;
				}else if(pos > self._current_draggable.max_pos){
					pos = self._current_draggable.max_pos;
				}

				self.set_pos(self._current_draggable, pos);

				if(opts.type == 'vertical'){
					if(self._current_draggable == self._min_dragger){
						self.fireEvent('minChange', [self._min_dragger.getPosition(self._scale).y - self._max_dragger.size]);
					}else if(self._current_draggable == self._max_dragger){
						self.fireEvent('maxChange', [self._max_dragger.getPosition(self._scale).y]);
					}
				}else{
					if(self._current_draggable == self._min_dragger){
						self.fireEvent('minChange', [self._min_dragger.getPosition(self._scale).x]);
					}else if(self._current_draggable == self._max_dragger){
						self.fireEvent('maxChange', [self._max_dragger.getPosition(self._scale).x - self._min_dragger.size]);
					}
				}
			}
		});

		$(document.body).addEvents({
			'touchmove': function(e){
				return !in_element;
			},

			'mousemove': function(e){
				if(!self.enabled || !self._current_draggable) return;

				if(e.preventDefault) e.preventDefault();

				var pos;

				if(opts.type == 'vertical'){
					pos = e.page.y - _self.getPosition().y - self._current_draggable.half_size;
				}else{
					pos = e.page.x - _self.getPosition().x - self._current_draggable.half_size;
				}

				if(pos < self._current_draggable.min_pos){
					pos = self._current_draggable.min_pos;
				}else if(pos > self._current_draggable.max_pos){
					pos = self._current_draggable.max_pos;
				}

				self.set_pos(self._current_draggable, pos);

				if(opts.type == 'vertical'){
					if(self._current_draggable == self._min_dragger){
						self.fireEvent('minChange', [self._min_dragger.getPosition(self._scale).y - self._max_dragger.size]);
					}else if(self._current_draggable == self._max_dragger){
						self.fireEvent('maxChange', [self._max_dragger.getPosition(self._scale).y]);
					}
				}else{
					if(self._current_draggable == self._min_dragger){
						self.fireEvent('minChange', [self._min_dragger.getPosition(self._scale).x]);
					}else if(self._current_draggable == self._max_dragger){
						self.fireEvent('maxChange', [self._max_dragger.getPosition(self._scale).x - self._min_dragger.size]);
					}
				}
			},

			'mouseleave': function(){
				if(!self.enabled) return;

				this.fireEvent('mouseup');
			},

			'mouseup': function(e){
				if(!self.enabled) return;

				if(opts.type == 'vertical'){
					if(self._current_draggable === self._min_dragger && self._current_draggable.getPosition().y != init_pos){
						self._max_dragger.max_pos = self._min_dragger.getPosition(self._scale).y - self._max_dragger.size;
						self.fireEvent('change');
					}else if (self._current_draggable === self._max_dragger && self._current_draggable.getPosition().y != init_pos){
						self._min_dragger.min_pos = self._max_dragger.getPosition(self._scale).y + self._max_dragger.size;
						self.fireEvent('change');
					}else{
						self._current_draggable = null;
					}
				}else{
					if(self._current_draggable === self._min_dragger && self._current_draggable.getPosition().x != init_pos){
						self._max_dragger.min_pos = self._min_dragger.getPosition(self._scale).x + self._min_dragger.size;
						self.fireEvent('change');
					}else if (self._current_draggable === self._max_dragger && self._current_draggable.getPosition().x != init_pos){
						self._min_dragger.max_pos = self._max_dragger.getPosition(self._scale).x - self._min_dragger.size;
						self.fireEvent('change');
					}else{
						self._current_draggable = null;
					}
				}
			},

			'touchend': function(e){
				document.body.fireEvent('mouseup');
			}
		});

		this.addEvents({
			'minChange': function(value){ 
				value = Math.ceil(value / self.step_px);

				//avoid empty value after resize
				if(value > labels.length - 1)
					value = labels.length - 1; 

				if(labels[value] != this._min_label.get('text')){
					this._min_label.set('text', labels[value]);
				}

				if (this._min_input_val && this._max_input_val) {
					if(labels[value] != this._min_input_val.get('value')){
						this._min_input_val.set('value', labels[value]);
					}
				}
				this.min_index = value;
			},

			'maxChange': function(value){
				value = Math.ceil(value / self.step_px);

				//avoid empty value after resize
				if(value > labels.length - 1)
					value = labels.length - 1;

				if(labels[value] != this._max_label.get('text')){
					this._max_label.set('text', labels[value]);
				}

				if (this._min_input_val && this._max_input_val) {
					if(labels[value] != this._max_input_val.get('value')){
						this._max_input_val.set('value', labels[value]);
					}
				}
				this.max_index = value;
			},

			'change': function(){
				var value;
				var valueChanged;

				var isMin = self._current_draggable == self._min_dragger || self._current_tab == self._min_dragger;
				var isMax = self._current_draggable == self._max_dragger || self._current_tab == self._max_dragger;

				if(opts.type == 'vertical'){
					if(isMin){
						value = Math.ceil((self._min_dragger.getPosition(self._scale).y - self._max_dragger.size) / self.step_px);
						this._min_input.set('value', values[value]);
						valueChanged = 'min';
					}else if(isMax){
						value = Math.ceil(self._max_dragger.getPosition(self._scale).y / self.step_px);
						this._max_input.set('value', values[value]);
						valueChanged = 'max';
					}
				}else{
					if(isMin){
						value = Math.ceil(self._min_dragger.getPosition(self._scale).x / self.step_px);

						//avoid empty value after resize
						if(value > labels.length - 1)
							value = labels.length - 1; 

						this._min_input.set('value', values[value]);
						valueChanged = 'min';
					}else if(isMax){
						value = Math.ceil((self._max_dragger.getPosition(self._scale).x - self._min_dragger.size) / self.step_px);

						//avoid empty value after resize
						if(value > labels.length - 1)
							value = labels.length - 1;

						this._max_input.set('value', values[value]);
						valueChanged = 'max';
					}
				}

				self._current_draggable = null;
				self._current_tab = null;

				self.fireEvent('complete', [this._min_input.get('value'), this._max_input.get('value'), this._min_label.get('text'), this._max_label.get('text'), valueChanged]);

			}
		});

		this.click_time = 0;

		self._scale.addEvents({
			'mousedown': function(e){
				if(!self.enabled) return;

				if(self._current_draggable){
					this.click_time = 3;
					return;
				}

				this.click_time++;

				if(this.click_time == 1){
					self._current_draggable = self._min_dragger;
				}else if(this.click_time == 2){
					self._current_draggable = self._max_dragger;
				}else{
					if(opts.type == 'vertical'){
						if(Math.abs(e.page.y - self._max_dragger.getPosition().y - self._max_dragger.size) <= Math.abs(self._min_dragger.getPosition().y - e.page.y)){
							self._current_draggable = self._max_dragger;
						}else{
							self._current_draggable = self._min_dragger;
						}
					}else{
						if(Math.abs(e.page.x - self._min_dragger.getPosition().x - self._min_dragger.size) <= Math.abs(e.page.x - self._max_dragger.getPosition().x)){
							self._current_draggable = self._min_dragger;
						}else{
							self._current_draggable = self._max_dragger;
						}
					}
				}

				document.body.fireEvent('mousemove', e);

				if(opts.type == 'vertical'){
					self._min_dragger.min_pos = self._max_dragger.getPosition(_self).y + self._max_dragger.getSize().y;
					self._max_dragger.max_pos = self._min_dragger.getPosition(_self).y - self._max_dragger.getSize().y;
				}else{
					self._min_dragger.max_pos = self._max_dragger.getPosition(_self).x - self._min_dragger.getSize().x;
					self._max_dragger.min_pos = self._min_dragger.getPosition(_self).x + self._min_dragger.getSize().x;
				}
			}
		});

		self._min_dragger.getElement('.veil').addEvents({
			'mousedown': function(e){
				if(!self.enabled) return;

				this.click_time = 3;
				self._scale.fireEvent('mousedown', e);
				self.fireEvent('change');
			}
		});

		self._max_dragger.getElement('.veil').addEvents({
			'mousedown': function(e){
				if(!self.enabled) return;

				this.click_time = 3;
				self._scale.fireEvent('mousedown', e);
				self.fireEvent('change');
			}
		});

		var min_label, max_label;

		if(opts.type == 'vertical'){
			min_label = this.values.length - 1;
			max_label = 0;
		}else{
			min_label = 0;
			max_label = this.values.length - 1;
		}

		var min_value = this._min_input.get('value');
		var max_value = this._max_input.get('value');

		this.values.each(function(e, i){
			if(min_value == e){
				min_label = i;
			}

			if(max_value == e){
				max_label = i;
			}
		});

		this.min_index = min_label;
		this.max_index = max_label;

		if(opts.type == 'vertical'){
			this.set_pos(this._min_dragger, this.min_index * this.step_px + this._min_dragger.getSize().y);
			this.set_pos(this._max_dragger, this.max_index * this.step_px);

			this._min_dragger.min_pos = this._max_dragger.getPosition(_self).y + this._max_dragger.getSize().y;
			this._max_dragger.max_pos = this._min_dragger.getPosition(_self).y - this._max_dragger.getSize().y;
		}else{
			this.set_pos(this._min_dragger, this.min_index * this.step_px);
			this.set_pos(this._max_dragger, this.max_index * this.step_px + this._max_dragger.getSize().x);

			this._min_dragger.max_pos = this._max_dragger.getPosition(_self).x - this._min_dragger.getSize().x;
			this._max_dragger.min_pos = this._min_dragger.getPosition(_self).x + this._min_dragger.getSize().x;
		}

		// set labels
		this._min_label.set('text', this.labels[this.min_index]);
		this._max_label.set('text', this.labels[this.max_index]);
		if (this._min_input_val && this._max_input_val) {
			this._min_input_val.set('value', this.labels[this.min_index]);
			this._max_input_val.set('value', this.labels[this.max_index]);
		}
	},

	reset: function(){ //resets rangeslider to min and max values
		var opts = this.options;

		if(opts.slider == 'on'){
			if(this.options.type == 'vertical'){
				var min_label = this.values.length - 1;
				var max_label = 0;

				this._min_input.set('value', this.values[this.values.length-1]);
				this._max_input.set('value', this.values[0]);

				this._min_label.set('text', this.labels[min_label]);
				this._max_label.set('text', this.labels[max_label]);

				if (this._min_input_val && this._max_input_val) {
					this._min_input_val.set('value', this.labels[this.min_index]);
					this._max_input_val.set('value', this.labels[this.max_index]);
				}

				this.set_pos(this._min_dragger, min_label * this.step_px + this._max_dragger.getSize().y);
				this.set_pos(this._max_dragger, 0);

				this._max_dragger.min_pos = 0;
				this._max_dragger.max_pos = this._scale.size - this._min_dragger.size - this._max_dragger.size;

				this._min_dragger.min_pos = this._max_dragger.size;
				this._min_dragger.max_pos = this._scale.size - this._min_dragger.size;
			}else{
				var min_label = 0;
				var max_label = this.values.length - 1;

				this._min_input.set('value', this.values[0]);
				this._max_input.set('value', this.values[this.values.length-1]);

				this._min_label.set('text', this.labels[min_label]);
				this._max_label.set('text', this.labels[max_label]);
				
				if (this._min_input_val && this._max_input_val) {
					this._min_input_val.set('value', this.labels[this.min_index]);
					this._max_input_val.set('value', this.labels[this.max_index]);
				}

				this.set_pos(this._min_dragger, min_label * this.step_px);
				this.set_pos(this._max_dragger, max_label * this.step_px + this._max_dragger.getSize().x);

				this._min_dragger.max_pos = this._max_dragger.getPosition(this._element).x - this._min_dragger.getSize().x;
				this._max_dragger.min_pos = this._min_dragger.getPosition(this._element).x + this._min_dragger.getSize().x;
			}

			this.click_time = 3;
		}else{
			var min_index = 0;
			var max_index = this.values.length - 1;

			this._min_select.selectedIndex = min_index;
			this._max_select.selectedIndex = max_index;

			var _min_options = this._min_select.getParent().getElements('li');
			var _max_options = this._max_select.getParent().getElements('li');

			if(_min_options.length > 0){
				_min_options[0].fireEvent('click');
			}

			if(_max_options.length > 0){
				_max_options[_max_options.length - 1].fireEvent('click');
			}
		}
	},

	resize: function(){
		if(Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') return;

		if(this.options.type == 'vertical') return;

		var new_size = this._scale.getSize().x;
		var _self = this._element;

		this._scale.size = new_size;

		this.playground = new_size - this._min_dragger.getSize().x - this._max_dragger.getSize().x;
		this.step_px = this.playground  / (this.values.length-1);

		this.set_pos(this._min_dragger, this.min_index*this.step_px);

		if(this.max_index == this.values.length-1){
			this.set_pos(this._max_dragger, new_size - this._max_dragger.getSize().x);
		}else{
			this.set_pos(this._max_dragger, this.max_index*this.step_px);
		}

		this._min_dragger.max_pos = this._max_dragger.getPosition(_self).x - this._min_dragger.getSize().x;
		this._max_dragger.min_pos = this._min_dragger.getPosition(_self).x + this._min_dragger.getSize().x;
		this._max_dragger.max_pos = this._scale.size - this._max_dragger.size;
	},



	set_pos: function(_el, pos){
		var style = (this.options.type == 'vertical'? 'top' : 'left');

		_el.setStyle(style, pos);

		if(_el._veil){
			var size;

			if(this.options.type == 'vertical'){
				if(_el === this._min_dragger){
					size = this._scale.size - pos - _el.getSize().y / 2;
				}else if(_el === this._max_dragger){
					size = pos + _el.getSize().y / 2;
				}
			}else{
				if(_el === this._min_dragger){
					size = pos + _el.getSize().x / 2;
				}else if(_el === this._max_dragger){
					size = this._element.getSize().x - (pos + _el.getSize().x / 2);
				}
			}

			style = (this.options.type == 'vertical'? 'height' : 'width');

			_el._veil.setStyle(style, size);
		}
	},

	enable: function(){
		this.enabled = true;
	},

	disable: function(){
		this.enabled = false;
	},

	get_min: function(){
		return this._min_input.get('value').toInt();
	},

	get_max: function(){
		return this._max_input.get('value').toInt();
	}
});
